import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Typography, TextField, Button } from '@material-ui/core';
import CustomPanel from '../../common/PanelTemplateWithMandatory';
import { Label, useLabelStyles } from '../../common/Label';
import I18n from '../../../config/locales';
import { isEmpty, isEqual } from 'lodash';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4, 3, 4, 3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(4, 1, 4, 1)
    }
  },
  inputWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
    }
  },
  inputField: {
    width: '45%',
    minWidth: theme.spacing(30),
    margin: theme.spacing(3, 1, 0, 1),
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(2)
    }
  },
  button: {
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(5)
  },
  instruction: {
    color: theme.palette.primary.lightBlack,
    fontSize: 14,
    fontWeight: 500
  }
}));

const ResetPassword = props => {
  const classes = useStyles();
  const labelClass = useLabelStyles();
  const {
    handlePasswordChange,
    resetPasswordData,
    handleReset,
    passwordMismatch,
    enableConfirmPasswordField,
    handleConfirmPasswordBlur
  } = props;
  const { old_pass = '', new_pass = '', new_pass_confirm = '' } = resetPasswordData;
  const isChangePasswordButtonDisabled = () => {
    return !(!isEmpty(new_pass) && !isEmpty(new_pass_confirm) && isEqual(new_pass, new_pass_confirm));
  };
  return (
    <CustomPanel header={I18n.t('accountInfo.change_password')}>
      <Box className={classes.root}>
        <Typography className={classes.instruction}>
          {I18n.t('resetPassword.instructions')}
        </Typography>
        <Grid className={classes.inputWrapper}>
          <TextField
            id="current_password"
            type="password"
            className={clsx(classes.inputField, labelClass.customLabel)}
            value={old_pass}
            onChange={e => handlePasswordChange(e, 'old_pass')}
            label={<Label text={I18n.t('resetPassword.currentPassword')} isRequired />}
          />
        </Grid>
        <Grid className={classes.inputWrapper}>
          <TextField
            id="new_password"
            type="password"
            className={clsx(classes.inputField, labelClass.customLabel)}
            value={new_pass}
            onChange={e => handlePasswordChange(e, 'new_pass')}
            label={<Label text={I18n.t('resetPassword.newPassword')} isRequired />}
          />
        </Grid>
        <Grid className={classes.inputWrapper}>
          <TextField
            id="confirm_new_password"
            type="password"
            className={clsx(classes.inputField, labelClass.customLabel)}
            value={new_pass_confirm}
            onChange={e => handlePasswordChange(e, 'new_pass_confirm')}
            onBlur={handleConfirmPasswordBlur}
            label={<Label text={I18n.t('resetPassword.confirmNewPassword')} isRequired />}
            disabled={!enableConfirmPasswordField}
            error={passwordMismatch}
            helperText={passwordMismatch && I18n.t('registration.passwordMismatch')}
          />
        </Grid>
        <Button
          className={classes.button}
          size="small"
          variant="contained"
          color="primary"
          disableElevation
          disabled={isChangePasswordButtonDisabled()}
          onClick={() => handleReset()}
        >
          {I18n.t('accountInfo.change_password')}
        </Button>
      </Box>
    </CustomPanel>
  );
};

export default ResetPassword;
